export const belonsToTheRestorantsProducts = ({ order }) => {
    let prod = [];
    
    order.items.map((item) => {
        if (item.product?.restaurant && (item.product.restaurant != order.restaurant))
            prod.push(item);
    });

    return prod;
}